import React, { useMemo } from 'react';
import { BodyRegular, BodyVerySmall } from '@shared/ui/atoms/fonts/Body';
import { CompanyHoliday } from '@features/holidays/services/CompanyHolidayService';
import moment from "moment";
import { useTranslation } from "react-i18next";
import Icon, { IconTypes } from '@shared/ui/atoms/icon/Icon';
import { SpaceBetweenRow } from '@features/settings/pages/StyleComponents';
import Colours from '@shared/ui/atoms/Colours';
import { useSelector } from "react-redux";
import { selectAllOfficeEntities } from '@features/desks/store/advanceHotDeskingSetup.duck';
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import { PopupPosition } from "./HolidayInfoAndApprovalPopup";
import { HolidayPopupShell } from "./HolidayPopupShell";

export function CompanyHolidayInfoPopup(props: Props) {
  const {companyHoliday} = props;
  const allOffices = useSelector(selectAllOfficeEntities);
  const date = useMemo(() => moment(companyHoliday.date), [companyHoliday]);
  const {t} = useTranslation();

  const offices = useMemo(() => {
    return allOffices.filter((o: OfficeEntity) => companyHoliday.companyHolidayOffices.includes(o.id));
  }, [allOffices, companyHoliday.companyHolidayOffices])

  return (
    <HolidayPopupShell isVisible={props.isVisible}
                       triggerRect={props.triggerRect}
                       popupPositioning={props.popupPositioning}
                       onMouseEnter={props.onMouseEnter}
                       onMouseLeave={props.onMouseLeave}>
      <SpaceBetweenRow style={{alignItems: 'center', marginBottom: 4}}>
        <BodyRegular colour={Colours.darkGreen} weight={600}>{t('holiday.company-holiday')}</BodyRegular>
        <Icon icon={IconTypes.Flag} />
      </SpaceBetweenRow>

      <BodyRegular style={{marginBottom: 2}} weight={600}>{companyHoliday.label}</BodyRegular>
      <BodyVerySmall>{`${date.format('Do MMMM')}`}</BodyVerySmall>

      {offices.length > 0 && <>
        <BodyRegular style={{marginTop: 8}} weight={600}>Offices applies to</BodyRegular>
        {offices.map((office: OfficeEntity, i: number) => <BodyVerySmall key={i}>{office.label}</BodyVerySmall>)}
      </>}
    </HolidayPopupShell>
  )
}

interface Props {
  companyHoliday: CompanyHoliday;
  popupPositioning?: PopupPosition;
  isVisible: boolean;
  triggerRect?: DOMRect;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}
